import { createApp } from 'petite-vue';
import Toastify from 'toastify-js';
import 'toastify-js/src/toastify.css';
import ClipboardJS from 'clipboard';
import { initializeApp } from 'firebase/app';
import {
  getDatabase,
  ref,
  set,
  update,
  push,
  onValue,
  remove,
  onChildRemoved,
  onChildAdded,
  connectDatabaseEmulator,
} from 'firebase/database';

import { v4 as uuidv4 } from 'uuid';

export default () => {
  const firebaseConfig = {
    apiKey: 'AIzaSyDQQDuPMOI020819o_ZtFpVmje7OHHwcYY',
    authDomain: 'oklava-b6495.firebaseapp.com',
    projectId: 'oklava-b6495',
    storageBucket: 'oklava-b6495.firebasestorage.app',
    messagingSenderId: '688171490895',
    appId: '1:688171490895:web:a2051bfad0806d072a943a',
    databaseURL: 'https://oklava-b6495-default-rtdb.europe-west1.firebasedatabase.app',
  };

  // eslint-disable-next-line
  const firebaseApp = initializeApp(firebaseConfig);

  const db = getDatabase();

  // eslint-disable-next-line
  if (localStorage.getItem('firebase-local-db') === true) {
    // Point to the RTDB emulator running on localhost.
    connectDatabaseEmulator(db, '127.0.0.1', 9000);
  }

  let isFirstTimeSession = false;

  const getInitialUserID = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const userIdFromURL = urlParams.get('food-user');
    const userIDFromStorage = localStorage.getItem('userId');

    if (userIdFromURL) {
      return userIdFromURL.toUpperCase();
    }

    if (userIDFromStorage) {
      return userIDFromStorage.toUpperCase();
    }

    if (!userIdFromURL && !userIDFromStorage) {
      const userID = uuidv4().substring(0, 6).toUpperCase();
      localStorage.setItem('userId', userID);

      isFirstTimeSession = true;

      return userID.toUpperCase();
    }

    return null;
  };

  const initalizeUserData = (userId) => {
    window.history.replaceState(null, null, `?food-user=${userId}`);
    localStorage.setItem('userId', userId);

    if (isFirstTimeSession) {
      update(ref(db, `starredUserFood/${userId}`), {
        createdOn: new Date().getTime(),
        lastUpdated: new Date().getTime(),
      });
    }
  };

  const userID = getInitialUserID();

  initalizeUserData(userID);

  const starredUserFoodList = ref(db, `starredUserFood/${userID}/foodListCMS`);

  // Component for each food item card to save and remove from saved list
  function foodItemComponent() {
    return {
      cmsReference: '',
      saved: false,
      firebaseArrayRef: '',
      onloadIsActiveInFirebase() {
        const setSavedStatusTrue = () => {
          this.saved = true;
        };

        const setSavedStatusFalse = () => {
          this.saved = false;
        };

        const assignFirebaseKey = (key) => {
          this.firebaseArrayRef = key;
        };

        onChildAdded(starredUserFoodList, (snapshot) => {
          const data = snapshot.val();

          if (data.item === this.cmsReference) {
            setSavedStatusTrue();
            assignFirebaseKey(snapshot.key);
          }
        });

        onChildRemoved(starredUserFoodList, (snapshot) => {
          const data = snapshot.val();

          if (data) {
            if (data.item === this.cmsReference) {
              setSavedStatusFalse();
            }
          }
        });
      },
      async saveFood(clickerElement) {
        const lockButton = () => {
          if (clickerElement) {
            // eslint-disable-next-line
            clickerElement.style.pointerEvents = 'none';
          }
        };

        const unlockButton = () => {
          if (clickerElement) {
            setTimeout(() => {
              // eslint-disable-next-line
              clickerElement.style.pointerEvents = 'auto';
            }, 1000);
          }
        };

        update(ref(db, `starredUserFood/${userID}`), {
          lastUpdated: new Date().getTime(),
        });

        lockButton();

        if (!this.saved) {
          await this.pushItemData();

          this.showToast('Favorit gespeichert');

          unlockButton();

          return true;
        }

        if (this.saved) {
          await this.deteleItemData(userID, this.firebaseArrayRef);

          this.showToast('Favorit entfernt');

          unlockButton();

          return true;
        }

        return false;
      },
      async pushItemData() {
        const itemCmsID = this.cmsReference;
        const newFoodListRef = push(starredUserFoodList);
        set(newFoodListRef, {
          item: itemCmsID,
          createdOn: new Date().getTime(),
        });

        this.firebaseArrayRef = newFoodListRef.key;
      },
      async deteleItemData(userId, refKey) {
        const itemRef = ref(db, `starredUserFood/${userId}/foodListCMS/${refKey}`);

        remove(itemRef);
      },
    };
  }

  // app is mounted below after finsweet attributes are loaded
  // so all items are available to mount the app and ensure full functionality
  createApp({
    foodItemComponent,
    userID,
    savedFoodList: [],
    showSaved: true,
    userIDClipboard: '',
    callServiceData: {
      phoneNumber: '',
      name: '',
    },
    shareData: {
      title:
        'Hey, schau dir die Speisekarte von Oklava.de an und die Speisen die ich favorisiert habe.',
      url: window.location.href,
    },
    showCallServiceModal: false,
    showWarnToast: false,
    reportMissingInput() {
      this.showWarnToast = true;
      setTimeout(() => {
        this.showWarnToast = false;
      }, 3000);
    },
    checkValidity() {
      const formElement = document.querySelector('form');

      const validity = formElement.checkValidity();

      if (!validity) {
        formElement.reportValidity();
        this.reportMissingInput();
      }

      return validity;
    },
    toggleCallServiceModal() {
      this.showCallServiceModal = !this.showCallServiceModal;
    },
    sendCallServiceData() {
      const validity = this.checkValidity();

      const formElement = document.querySelector('form');

      if (validity) {
        window.hcaptcha
          .execute({ async: true })
          .then(({ response }) => {
            this.captchaToken = response;
            formElement.submit();
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    toggleSavedList() {
      this.showSaved = !this.showSaved;
      // if (this.savedLocalFoodStorageLength !== 0) {
      // }
    },
    showToast(text) {
      Toastify({
        text,
        duration: 3000,
        newWindow: false,
        close: false,
        gravity: 'bottom', // `top` or `bottom`
        position: 'left', // `left`, `center` or `right`
        stopOnFocus: false, // Prevents dismissing of toast on hover
        style: {
          background: 'var(--text-color--text-secondary)',
        },
      }).showToast();
    },
    initalizeCopyToClipboard(element) {
      this.userIDClipboard = new ClipboardJS(element);
    },
    copyToClipboard() {
      this.userIDClipboard.on('success', () => {
        this.showToast('Code kopiert');
      });

      this.userIDClipboard.on('error', () => {
        this.showToast('Fehler beim Kopieren');
      });
    },
    get canShareLink() {
      try {
        return navigator.canShare(this.shareData);
      } catch (error) {
        return false;
      }
    },
    shareLink() {
      navigator.share(this.shareData);
    },
    // call in mounted component
    getSavedFoodList() {
      onValue(starredUserFoodList, (snapshot) => {
        const data = snapshot.val();

        this.savedFoodList = [];

        // if (!data) {
        //   this.showSaved = false;
        // }

        if (data) {
          const firebaseArrayKeys = Object.keys(data);

          firebaseArrayKeys.forEach((key) => {
            this.savedFoodList.push({ [key]: data[key].item });
          });
        }
      });
    },
    get savedLocalFoodStorageLength() {
      if (this.savedFoodList === null) {
        return 0;
      }

      return this.savedFoodList.length;
    },
  }).mount('#food-list-component');
};
